import { useState } from 'react'
import { FaBars, FaTimes, FaShoppingCart } from 'react-icons/fa'

const Header = ({ restaurant }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const name = restaurant?.name || 'Bread & Sandwich'
  const logo = restaurant?.logo
  const color = restaurant?.primaryColor || '#ff6b00'
  // Initials for logo placeholder
  const initials = name.split(' ').map(w => w[0]).join('').slice(0, 3).toUpperCase()

  return (
    <header style={{
      backgroundColor: 'rgba(0, 0, 0, 0.9)',
      padding: '20px 0',
      position: 'sticky',
      top: 0,
      zIndex: 1000,
      backdropFilter: 'blur(10px)',
      borderBottom: '1px solid rgba(255, 107, 0, 0.2)'
    }}>
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto',
        padding: '0 40px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        {/* Logo */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          {logo ? (
            <img src={logo} alt={name} style={{ width: '45px', height: '45px', borderRadius: '50%', objectFit: 'cover', boxShadow: `0 0 20px ${color}80` }} />
          ) : (
            <div style={{
              width: '45px', height: '45px', backgroundColor: color, borderRadius: '50%',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontWeight: 'bold', color: 'white', fontSize: '16px',
              boxShadow: `0 0 20px ${color}80`
            }}>
              {initials}
            </div>
          )}
          <h1 style={{ fontSize: '28px', fontWeight: 'bold', color: 'white', margin: 0, letterSpacing: '1px' }}>
            {name}
          </h1>
        </div>

        {/* Desktop Navigation */}
        <nav style={{ display: 'flex' }}>
          <ul style={{
            display: 'flex',
            listStyle: 'none',
            gap: '40px',
            margin: 0,
            padding: 0,
            alignItems: 'center'
          }}>
            <li>
              <a href="#" style={{
                color: 'white',
                textDecoration: 'none',
                fontSize: '16px',
                fontWeight: '500',
                transition: 'all 0.3s',
                padding: '8px 0',
                position: 'relative',
                ':hover': { 
                  color: '#ff6b00',
                  ':after': {
                    content: '""',
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    height: '2px',
                    backgroundColor: '#ff6b00',
                    transform: 'scaleX(1)'
                  }
                },
                ':after': {
                  content: '""',
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  width: '100%',
                  height: '2px',
                  backgroundColor: '#ff6b00',
                  transform: 'scaleX(0)',
                  transition: 'transform 0.3s'
                }
              }}>
                Accueil
              </a>
            </li>
            <li>
              <a href="#menu" style={{
                color: 'white',
                textDecoration: 'none',
                fontSize: '16px',
                fontWeight: '500',
                transition: 'all 0.3s',
                padding: '8px 0',
                position: 'relative',
                ':hover': { 
                  color: '#ff6b00',
                  ':after': {
                    content: '""',
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    height: '2px',
                    backgroundColor: '#ff6b00',
                    transform: 'scaleX(1)'
                  }
                },
                ':after': {
                  content: '""',
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  width: '100%',
                  height: '2px',
                  backgroundColor: '#ff6b00',
                  transform: 'scaleX(0)',
                  transition: 'transform 0.3s'
                }
              }}>
                Menu
              </a>
            </li>
            <li>
              <a href="#footer" style={{
                color: 'white',
                textDecoration: 'none',
                fontSize: '16px',
                fontWeight: '500',
                transition: 'all 0.3s',
                padding: '8px 0',
                position: 'relative',
                ':hover': { 
                  color: '#ff6b00',
                  ':after': {
                    content: '""',
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    height: '2px',
                    backgroundColor: '#ff6b00',
                    transform: 'scaleX(1)'
                  }
                },
                ':after': {
                  content: '""',
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  width: '100%',
                  height: '2px',
                  backgroundColor: '#ff6b00',
                  transform: 'scaleX(0)',
                  transition: 'transform 0.3s'
                }
              }}>
                À propos
              </a>
            </li>
            <li>
              <a href="#footer" style={{
                color: 'white',
                textDecoration: 'none',
                fontSize: '16px',
                fontWeight: '500',
                transition: 'all 0.3s',
                padding: '8px 0',
                position: 'relative',
                ':hover': { 
                  color: '#ff6b00',
                  ':after': {
                    content: '""',
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    height: '2px',
                    backgroundColor: '#ff6b00',
                    transform: 'scaleX(1)'
                  }
                },
                ':after': {
                  content: '""',
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  width: '100%',
                  height: '2px',
                  backgroundColor: '#ff6b00',
                  transform: 'scaleX(0)',
                  transition: 'transform 0.3s'
                }
              }}>
                Contact
              </a>
            </li>
            <li>
              <a href="#menu" style={{
                backgroundColor: '#ff6b00',
                color: 'white',
                padding: '12px 35px',
                borderRadius: '30px',
                textDecoration: 'none',
                fontWeight: '600',
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                fontSize: '16px',
                transition: 'all 0.3s',
                boxShadow: '0 5px 15px rgba(255, 107, 0, 0.4)',
                ':hover': {
                  transform: 'translateY(-3px)',
                  boxShadow: '0 8px 25px rgba(255, 107, 0, 0.6)'
                }
              }}>
                <FaShoppingCart /> Order Now
              </a>
            </li>
          </ul>
        </nav>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          style={{
            background: 'none',
            border: 'none',
            color: 'white',
            fontSize: '24px',
            cursor: 'pointer',
            display: 'none'
          }}
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.95)',
          backdropFilter: 'blur(20px)',
          zIndex: 999,
          padding: '30px',
          borderTop: '1px solid rgba(255, 107, 0, 0.3)'
        }}>
          <ul style={{
            listStyle: 'none',
            margin: 0,
            padding: 0
          }}>
            {['Accueil', "Menu", 'À propos'].map((item) => (
              <li key={item} style={{ marginBottom: '20px' }}>
                <a 
                  href={`#${item.toLowerCase().replace("'s", '').replace(' ', '-')}`}
                  onClick={() => setMenuOpen(false)}
                  style={{
                    color: 'white',
                    textDecoration: 'none',
                    fontSize: '20px',
                    display: 'block',
                    padding: '15px 0',
                    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                    transition: 'all 0.3s',
                    ':hover': {
                      color: '#ff6b00',
                      paddingLeft: '15px'
                    }
                  }}
                >
                  {item}
                </a>
              </li>
            ))}
            <li style={{ marginBottom: '20px' }}>
              <a 
                href="#footer"
                onClick={() => setMenuOpen(false)}
                style={{
                  color: 'white',
                  textDecoration: 'none',
                  fontSize: '20px',
                  display: 'block',
                  padding: '15px 0',
                  borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                  transition: 'all 0.3s',
                  ':hover': {
                    color: '#ff6b00',
                    paddingLeft: '15px'
                  }
                }}
              >
                Contact
              </a>
            </li>
            <li style={{ marginTop: '30px' }}>
              <a 
                href="#"
                onClick={() => setMenuOpen(false)}
                style={{
                  backgroundColor: '#ff6b00',
                  color: 'white',
                  padding: '15px 30px',
                  borderRadius: '30px',
                  textDecoration: 'none',
                  fontSize: '18px',
                  fontWeight: '600',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '10px',
                  transition: 'all 0.3s',
                  ':hover': {
                    backgroundColor: '#e55a00'
                  }
                }}
              >
                <FaShoppingCart /> Order Now
              </a>
            </li>
          </ul>
        </div>
      )}

      {/* Mobile Responsive CSS */}
      <style jsx>{`
        @media (max-width: 768px) {
          /* Show mobile menu button */
          button[style*="display: none"] {
            display: block !important;
          }
          
          /* Hide desktop nav */
          nav {
            display: none !important;
          }
          
          /* Adjust header for mobile */
          div[style*="max-width: 1400px"] {
            padding: 0 20px !important;
          }
          
          /* Adjust logo for mobile */
          h1 {
            font-size: 20px !important;
          }
          
          div[style*="width: 45px"] {
            width: 35px !important;
            height: 35px !important;
            font-size: 16px !important;
          }
        }
      `}</style>
    </header>
  )
}

export default Header